module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0035.jpg?v=55a24699";